import React from "react"
import slugify from "slugify"
import { SectionFooter } from "@alexanderathoodly/ui-library"
import { createButtonWithAnalitics } from "../analytics/actions"
import { BlockFooterProps } from "./types"

const BlockFooter = ({ footertext, buttons, position }: BlockFooterProps): JSX.Element => {
    const primaryButton =
        buttons && buttons.length > 0 ? createButtonWithAnalitics(buttons[0], slugify(position)) : undefined
    const secondaryButton =
        buttons && buttons.length > 1 ? createButtonWithAnalitics(buttons[1], slugify(position)) : undefined
    return (
        <SectionFooter primaryButton={primaryButton} secondaryButton={secondaryButton}>
            {footertext}
        </SectionFooter>
    )
}

export { BlockFooter }
